// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__12W50","overflowing":"ReadFullNote_overflowing__14nRk"};